<template>
  <div class="promo-code">
    <div class="loading-box" v-if="loading">
      <Loader color="white" :small="true"/>
    </div>
    <div class="code-box" v-if="!loading">
      <div class="label">Code</div>
      <div class="value">{{ data.code }}</div>
    </div>
    <div class="plan-box" v-if="!loading">
      <div class="label">Plan Name</div>
      <div class="value">{{ planData.fullName }}</div>
    </div>
    <div class="expiration-date-box" v-if="!loading">
      <div class="label">Expiration Date</div>
      <div class="value">{{ getExpirationDate }}</div>
    </div>
    <div class="share-box" v-if="!loading">
      <font-awesome-icon icon="share-alt" class="icon" @click="onShare"/>
    </div>
    <div class="delete-box" v-if="!loading">
      <font-awesome-icon icon="trash" class="icon" @click="onDelete"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import alert from '@/lib/alert'
import Loader from '@/components/Loader'

export default {
  name: 'PromoCode',
  props: {
    data: Object
  },
  data() {
    return {
      planData: null,
      loading: true
    }
  },
  components: {
    Loader
  },
  methods: {
    loadPlanData() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadPlanData`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          planId: this.data.plan
        }
      }).then(response => {
        this.planData = response.data.planData;
        this.loading = false;
      }).catch(err => {
        console.log(err);
        this.loading = false;
      })
    },
    onShare() {
      let input = document.createElement('input');
      input.id = 'promoCode';
      input.value = `${window.location.origin}/?action=register&promo_code=${this.data.code}`;
      document.body.appendChild(input);
      document.querySelector('#promoCode').select();
      document.execCommand('copy');
      document.body.removeChild(input);
      swal({
        title: "Link Copied",
        icon: "success",
        timer: 1000,
      });
    },
    onDelete() {
      swal("Are you sure you want to delete code?", {
        icon: "warning",
        dangerMode: true,
        buttons: true,
      }).then(result => {
        if(result) {
          axios({
            method: 'post',
            url: `${process.env.VUE_APP_SERVER_URL}deletePromoCode`,
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token') 
            },
            data: {
              promoCodeId: this.data._id
            }
          }).then(() => {
            alert.showSuccess('Promo Code Deleted', 1000);
            this.$emit('reload');
          }).catch(err => {
            console.log(err);
          })
        }
      })
    }
  },
  computed: {
    getExpirationDate() {
      let date = new Date(this.data.expirationDate);
      let day = date.getDate();
      let month = date.getMonth();
      let year = date.getFullYear();
      let monthArray = new Array();
      monthArray[0] = "January";
      monthArray[1] = "February";
      monthArray[2] = "March";
      monthArray[3] = "April";
      monthArray[4] = "May";
      monthArray[5] = "June";
      monthArray[6] = "July";
      monthArray[7] = "August";
      monthArray[8] = "September";
      monthArray[9] = "October";
      monthArray[10] = "November";
      monthArray[11] = "December";
      return `${day} ${monthArray[month]} ${year}`;
    }
  },
  mounted() {
    this.loadPlanData();
  }
}
</script>

<style lang="scss" scoped>
.promo-code {
  width: 100%;
  height: 4rem;
  display: flex;
  flex-direction: row;
  border-top: 2px solid rgb(199, 199, 199);

  @media (max-width: 700px) {
    width: 90%;
    height: auto;
    border: 2px solid rgb(199, 199, 199);
    margin-top: 1rem;
    // flex-direction: column;
    flex-wrap: wrap;
  }

  .loading-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .code-box {
    flex: 3;
    height: 100%;
    display: flex;
    color: rgb(134, 134, 134);
    font-weight: bold;

    .label {
      display: none;
      align-items: center;
      justify-content: center;
      height: 100%;
      flex: 1;
      background-color: rgb(199, 199, 199);
    }

    .value {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: 1rem;
    }


    @media (max-width: 700px) {
      flex: unset;
      width: 100%;
      height: 3rem;
      border-bottom: 2px solid rgb(182, 182, 182);

      .label {
        display: flex;
      }

      .value {
        flex: 1;
        justify-content: center;
        padding-left: 0rem;
      }
    }
    @media (max-width: 400px) {
      .label {
        flex: 0.8;
      }
    }
  }

  .plan-box {
    flex: 1;
    height: 100%;
    display: flex;
    color: rgb(134, 134, 134);
    font-weight: bold;
    border-left: 2px dashed rgb(199, 199, 199);

    .label {
      display: none;
      align-items: center;
      justify-content: center;
      height: 100%;
      flex: 1;
      background-color: rgb(199, 199, 199);
    }

    .value {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: capitalize;
    }

    @media (max-width: 700px) {
      flex: unset;
      width: 100%;
      height: 3rem;
      border-left: none;
      border-bottom: 2px solid rgb(182, 182, 182);

      .label {
        display: flex;
      }

      .value {
        flex: 1;
        justify-content: center;
        padding-left: 0rem;
      }
    }
    @media (max-width: 400px) {
      .label {
        flex: 0.8;
      }
    }
  }

  .expiration-date-box {
    flex: 1.5;
    height: 100%;
    display: flex;
    color: rgb(134, 134, 134);
    font-weight: bold;
    border-left: 2px dashed rgb(199, 199, 199);

    .label {
      display: none;
      align-items: center;
      justify-content: center;
      height: 100%;
      flex: 1;
      background-color: rgb(199, 199, 199);
    }

    .value {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: capitalize;
    }

    @media (max-width: 700px) {
      flex: unset;
      width: 100%;
      height: 3rem;
      border-left: none;
      border-bottom: 2px solid rgb(182, 182, 182);

      .label {
        display: flex;
      }

      .value {
        flex: 1;
        justify-content: center;
        padding-left: 0rem;
      }
    }
    @media (max-width: 400px) {
      .label {
        flex: 0.8;
      }
    }
  }

  .share-box {
    flex: 0.75;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(134, 134, 134);
    font-weight: bold;
    border-left: 2px dashed rgb(199, 199, 199);
    @media (max-width: 700px) {
      flex: unset;
      width: 50%;
      height: 3rem;
      border: none;
    }

    .icon {
      font-size: 1.3rem;
      transition: 0.3s;

      &:hover {
        cursor: pointer;
        color: #11b6a5;
      }
    }
  }

  .delete-box {
    flex: 0.75;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(134, 134, 134);
    font-weight: bold;
    border-left: 2px dashed rgb(199, 199, 199);
    @media (max-width: 700px) {
      flex: unset;
      width: 50%;
      height: 3rem;
      border: none;
    }

    .icon {
      font-size: 1.3rem;
      transition: 0.3s;

      &:hover {
        cursor: pointer;
        color: #b61c11;
      }
    }
  }
}
</style>